import FIELD_TYPES from '../../../configs/fieldTypes';

export default {
  start: [FIELD_TYPES.DATE],
  end: [FIELD_TYPES.DATE],
  title: [FIELD_TYPES.TEXT, FIELD_TYPES.CODE],
  employee: [FIELD_TYPES.USER],
  progress: [FIELD_TYPES.PROGRESS, FIELD_TYPES.NUMBER],
  color: [FIELD_TYPES.DROPDOWN],
  link: [FIELD_TYPES.OBJECT],
};
